import { MenuDTO, RouteData } from "src/app/models/Menu/MenuDTO";

let selectedMenu: MenuDTO;

export function subMenusIterator(
  menuElement: MenuDTO,
  activeRouteData: RouteData
) {
  const { code, subMenus } = menuElement;

  if (code && code === "folder") {
    for (const subMenuEl of subMenus) {
      subMenusIterator(subMenuEl, activeRouteData);
    }
  } else {
    checkSelectedMenu(menuElement, activeRouteData);
  }

  return selectedMenu;
}

function checkSelectedMenu(menuElement: MenuDTO, activeRouteData: RouteData) {
  const { code, description } = menuElement;
  const { code: activeRouteCode } = activeRouteData;

  if (code && description && code === activeRouteCode) {
    selectedMenu = menuElement;
  }
}
